import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { blogPreviews } from "@/mocks/homeContent";

export default function Footer() {
  return (
    <footer className="bg-secondary-100 pt-14 md:pt-20 pb-8 px-4 md:px-8 lg:px-12">
      <div className="max-w-6xl mx-auto">
        <div className="bg-background-50 rounded-lg p-6 md:p-10">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            <div className="lg:w-1/4">
              <Link to="/" className="flex items-center gap-2 mb-4 group">
                <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-file-list-3-line text-background-50 text-lg"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
                  Mulebuy Spreadsheet
                </span>
              </Link>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4">
                Your trusted guide to spreadsheet-based product sourcing. We help global buyers discover, compare, and purchase products from verified China suppliers.
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-700 hover:bg-secondary-300 transition-colors"
                  aria-label="Visit main website"
                >
                  <i className="ri-global-line"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com/"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-200 text-secondary-700 hover:bg-secondary-300 transition-colors"
                  aria-label="Shopping cart"
                >
                  <i className="ri-shopping-cart-line"></i>
                </a>
              </div>
            </div>

            <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 gap-6">
              <div>
                <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-3">
                  Quick Links
                </h4>
                <ul className="space-y-2">
                  <li>
                    <Link to="/" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      Home
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog/what-is-mulebuy-spreadsheet-complete-beginner-guide" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      Beginner Guide
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog/how-mulebuy-spreadsheet-works" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      How It Works
                    </Link>
                  </li>
                  <li>
                    <Link to="/blog/why-spreadsheet-buying-trending" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      Market Trends
                    </Link>
                  </li>
                  <li>
                    <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                      Mulebuy Spreadsheet
                    </a>
                  </li>
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-3">
                  Top Categories
                </h4>
                <ul className="space-y-2">
                  {categories.slice(0, 6).map((cat) => (
                    <li key={cat.name}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors"
                      >
                        {cat.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h4 className="text-xs font-semibold text-foreground-900 uppercase tracking-wider mb-3">
                  Popular Guides
                </h4>
                <ul className="space-y-2">
                  {blogPreviews.slice(0, 5).map((b) => (
                    <li key={b.slug}>
                      <Link
                        to={`/blog/${b.slug}`}
                        className="text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors block truncate max-w-[180px]"
                      >
                        {b.title.length > 35 ? b.title.slice(0, 35) + "..." : b.title}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
              <p className="text-xs text-foreground-500">
                &copy; {new Date().getFullYear()} Mulebuy Spreadsheet. All rights reserved. This site provides informational guidance only.
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-500">
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="hover:text-primary-600 transition-colors">
                  Privacy
                </a>
                <span>|</span>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="hover:text-primary-600 transition-colors">
                  Terms
                </a>
                <span>|</span>
                <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="hover:text-primary-600 transition-colors">
                  Contact
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}